const initLottie = (container, loop = false) => {
  return lottie.loadAnimation({
    container: container,
    renderer: "svg",
    loop: loop,
    autoplay: true,
    path: container.getAttribute("data-path"),
  });
};

const loaderContainer = document.querySelector(".js-loader-lottie");

if (loaderContainer) {
  const loaderLottie = initLottie(loaderContainer, true);

  loaderLottie.addEventListener("DOMLoaded", () => {
    loaderLottie.setSpeed(0.5);
  });
}
